import { ArrowUp } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { CONTACT, SIGN_IN_URL } from "@/content";
import { LogoMark } from "./Logo";
import { goTo, ease } from "./motion";

const LINKS = ["property", "gallery", "plans", "company", "club", "contact"];

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#0C3440] text-white overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 pt-20 md:pt-28">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <LogoMark className="h-12 w-12 text-[#7FD9D6]" />
            <p className="mt-6 max-w-sm font-display text-3xl leading-tight">{t.footer.tagline}</p>
          </div>
          <nav className="md:col-span-3 grid grid-cols-2 gap-3 content-start">
            {LINKS.map((k) => (
              <button key={k} onClick={() => goTo(k)} data-testid={`footer-link-${k}`} className="text-start text-sm text-[#B9D3D6] hover:text-white transition-colors">{t.nav[k]}</button>
            ))}
          </nav>
          <div className="md:col-span-4 space-y-3 text-sm text-[#B9D3D6]">
            <a href={`mailto:${CONTACT.email}`} className="block hover:text-white transition-colors" dir="ltr" data-testid="footer-email">{CONTACT.email}</a>
            <a href={`tel:${CONTACT.tel}`} dir="ltr" className="block hover:text-white transition-colors rtl:text-right" data-testid="footer-phone">{CONTACT.phone}</a>
            <p>{t.contact.office}</p>
            <a href={SIGN_IN_URL} target="_blank" rel="noopener noreferrer" className="inline-block pt-2 text-[#7FD9D6] hover:text-white transition-colors" data-testid="footer-signin-link">{t.nav.signIn} ↗</a>
          </div>
        </div>
      </div>
      <motion.p
        initial={{ y: "40%", opacity: 0 }}
        whileInView={{ y: "0%", opacity: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.6, ease }}
        className="select-none text-center font-display leading-[0.8] tracking-[0.06em] text-[22vw] text-[#134654] mt-12"
        dir="ltr"
        aria-hidden="true"
      >
        OGEN
      </motion.p>
      <div className="mx-auto flex max-w-[1440px] flex-wrap items-center justify-between gap-4 border-t border-white/10 px-5 md:px-10 py-6 text-[12px] text-[#9FC0C4]">
        <p>© {new Date().getFullYear()} OGEN Hospitality · {t.footer.rights}</p>
        <button onClick={() => goTo("top")} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-back-top">
          {t.footer.backTop}<ArrowUp className="h-3.5 w-3.5" />
        </button>
      </div>
    </footer>
  );
};
